module.exports = __webpack_public_path__ + "img/hiil-logo-dark-bg.357a7475.png";